function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#E4E6E8"
}), React.createElement("path", {
  fill: "#828A96",
  d: "M13.004 12l3.286-3.286a.71.71 0 00-1.004-1.006L12 10.994 8.714 7.708a.711.711 0 10-1.006 1.006L10.994 12l-3.286 3.286a.711.711 0 101.006 1.006L12 13.006l3.286 3.286a.711.711 0 001.006-1.006L13.004 12z"
}));

var SvgClearInput = function SvgClearInput(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNFNEU2RTgiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjODI4QTk2IiBkPSJNMTMuMDA0IDEybDMuMjg2LTMuMjg2YS43MS43MSAwIDAwLTEuMDA0LTEuMDA2TDEyIDEwLjk5NCA4LjcxNCA3LjcwOGEuNzExLjcxMSAwIDEwLTEuMDA2IDEuMDA2TDEwLjk5NCAxMmwtMy4yODYgMy4yODZhLjcxMS43MTEgMCAxMDEuMDA2IDEuMDA2TDEyIDEzLjAwNmwzLjI4NiAzLjI4NmEuNzExLjcxMSAwIDAwMS4wMDYtMS4wMDZMMTMuMDA0IDEyeiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgClearInput as ReactComponent };